import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// Live error monitoring. DSN comes from the environment (prod-admin Sentry project);
// an empty DSN (local dev / staging-until-set) makes Sentry.init a no-op, so those
// environments never report. Guarded so a Sentry bootstrap failure can't block the app.
// `release` (the build's git SHA) is baked into the bundle at build time by the
// prebuild hook so stack frames map to a specific deploy.
if (environment.sentryDsn) {
    try {
        Sentry.init({
            dsn: environment.sentryDsn,
            environment: environment.environmentName,
            release: environment.release || undefined,
            integrations: [
                new Integrations.BrowserTracing({
                    routingInstrumentation: Sentry.routingInstrumentation,
                }),
            ],
            tracesSampleRate: 0.1,
        });
    } catch (err) {
        console.warn('[sentry] init failed:', err);
    }
}

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
